import type { CatalogItem } from "@/lib/airtable";
import { itemMatchesTaxonomy } from "@/lib/taxonomyMatch";

export const CATEGORY_CONFIG = [
  { slug: "necklaces", label: "Necklaces", match: "necklace" },
  { slug: "rings", label: "Rings", match: "ring" },
  { slug: "earrings", label: "Earrings", match: "earring" },
  { slug: "bracelets", label: "Bracelets", match: "bracelet" }
] as const;

export type CategorySlug = (typeof CATEGORY_CONFIG)[number]["slug"];

export const getCategoryBySlug = (slug: string) =>
  CATEGORY_CONFIG.find((category) => category.slug === slug);

/**
 * Word-boundary match that accepts the singular OR plural form (ring / rings)
 * across the type, tags, and subcategory arrays. This catches catalog rows
 * that label themselves with non-canonical types (e.g. "Pendant" tagged
 * "Necklaces") so they still surface on the right category page. Shares the
 * matcher with the subcategory filter (see lib/taxonomyMatch).
 */
export const filterItemsByCategory = (items: CatalogItem[], match: string) =>
  items.filter((item) => itemMatchesTaxonomy(item, match));
